export default "__VITE_ASSET__DQnw5n9O__"